


















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TabList extends Vue {
  @Prop(Array) readonly tabList!: []
  // tabClick (text:string) {
  //   this.$emit('tabChanged', text)
  // }
}
